import React from 'react'
import PropTypes from 'prop-types'
import { CCol, CRow, CSpinner } from '@coreui/react-pro'

const PageLoading = ({ label = 'Загрузка', className = 'py-4' }) => (
  <CRow className={className}>
    <CCol className="text-center text-secondary">
      <CSpinner size="sm" color="info" className="me-2" />
      {label}
    </CCol>
  </CRow>
)

PageLoading.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
}

export default PageLoading
